export default "__VITE_ASSET__743a3542__"